// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".mini-shop-menu-bar-container[data-v-6604cab4]{max-width:1440px;width:100%;margin-left:auto;margin-right:auto;height:35px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
